// @ts-check

import i18n from '@/lang';

// 快递应收
export const TABLE_HEADER = [
  // 应收主体
  { prop: 'providerName', label: i18n.t('basicData.businessPrincipal'), width: 200, fixed: 'left', highlight: false, disabled: false },
  // 网点
  { prop: 'siteName', label: i18n.t('basicData.Outlets'), width: 200, fixed: 'left', highlight: false, disabled: false },
  // 发件人州
  { prop: 'senderState', label: i18n.t('newOrder.SenderState'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 发件人城市
  { prop: 'senderCity', label: i18n.t('collectionCenter.SenderCity'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 发件人邮编
  { prop: 'senderZipcode', label: i18n.t('newOrder.senderZipCode'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 订单号
  { prop: 'orderNumber', label: i18n.t('basicData.OrderNumber'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 所属分区
  { prop: 'partitionName', label: i18n.t('basicData.PartitionName'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 收件人州
  { prop: 'receiveState', label: i18n.t('newOrder.RecipientState'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 收件人城市
  { prop: 'receiveCity', label: i18n.t('collectionCenter.receiveCity'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 收件人邮编
  { prop: 'receiveZipcode', label: i18n.t('collectionCenter.Recipientzc'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 业务单号
  { prop: 'waybillNumber', label: i18n.t('receivablePayable.TicketNumber'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 客户单号
  { prop: 'customerNumber', label: i18n.t('receivablePayable.CustomerTrackingNumber'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 订单状态
  { prop: 'status', label: i18n.t('collectionCenter.OrderStatus'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 客户名称
  { prop: 'customerAlias', label: i18n.t('basicData.CustomerName'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 客户编号
  { prop: 'customerId', label: i18n.t('basicData.CustomerCode'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 客户出仓时间
  { prop: 'customerSendTime', label: i18n.t('newOrder.clientExitTime'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 商户
  { prop: 'merchantName', label: i18n.t('collectionCenter.CommercialOwner'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 支付方式
  { prop: 'payType', label: i18n.t('ClaimsManagement.PaymentMethod'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 计费重量
  { prop: 'chargeWeight', label: i18n.t('receivablePayable.BillableWeight'), width: 120, fixed: 'left', highlight: true, disabled: false },
  // 应收总费用
  { prop: 'totalFee', label: i18n.t('basicData.TotalFeesReceivable'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // IBS
  { prop: 'ibsFee', label: i18n.t('basicData.IBS'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 业务类型
  { prop: 'businessType', label: i18n.t('collectionCenter.businessT'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 货物类型
  { prop: 'cargoType', label: i18n.t('placeOrder.cargoType'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 服务类型
  { prop: 'expressType', label: i18n.t('GlobalSetObj.serviceTypes'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 揽收方式
  { prop: 'collectType', label: i18n.t('collectionCenter.lanshouTypee'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 揽收类型
  { prop: 'collectionCategory', label: i18n.t('basicData.CollectionType'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 揽收时间
  { prop: 'collectTime', label: i18n.t('collectionCenter.lanshouT'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 账单类型
  { prop: 'billType', label: i18n.t('receivablePayable.billType'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 包裹类型
  { prop: 'orderPackageType', label: i18n.t('placeOrder.packageType'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 来源
  { prop: 'feeSource', label: i18n.t('receivablePayable.source'), width: 120, fixed: 'left', highlight: false, disabled: false }
];

// 整车应收
export const VEHICLERECEIVABLES_COLUMN = [
  // 订单号
  { prop: 'orderNumber', label: i18n.t('basicData.OrderNumber'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 客户订单号
  { prop: 'customerNumber', label: i18n.t('newOrder.orderNumber'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 运单号
  { prop: 'waybillNumber', label: i18n.t('GlobalSetObj.waybillNumber'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 运输时间
  { prop: 'transportTime', label: i18n.t('trajectory.TransitTime'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 财务结算单号
  { prop: 'settlementNumber', label: i18n.t('basicData.FinancialSettlementDocumentNumber'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 下单客户
  { prop: 'orderCustomerAlias', label: i18n.t('basicData.OrderingCustomer'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 结算客户
  { prop: 'settlementCustomerAlias', label: i18n.t('basicData.SettlementCustomer'), width: 180, fixed: 'left', highlight: false, disabled: false },
  // 订单类型
  { prop: 'orderTypeAlias', label: i18n.t('newOrder.OrderType'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 结算里程
  { prop: 'totalMileage', label: i18n.t('basicData.SettlementMileage'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 车型
  { prop: 'vehicleTypeAlias', label: i18n.t('vehicle.modelLabel'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 装卸类型
  { prop: 'loadingTypeAlias', label: i18n.t('basicData.UnloadingType'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 付款方式
  { prop: 'paymentMethodAlias', label: i18n.t('basicData.PaymentMethod'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 应收总费用
  { prop: 'totalFee', label: i18n.t('basicData.TotalFeesReceivable'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // IBS
  { prop: 'ibsFee', label: i18n.t('basicData.IBS'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // 发件人
  { prop: 'senderAlias', label: i18n.t('collectionCenter.addresser'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 发件人州
  { prop: 'senderState', label: i18n.t('newOrder.SenderState'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 发件人城市
  { prop: 'senderCity', label: i18n.t('collectionCenter.SenderCity'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 发件人邮编
  { prop: 'senderZipcode', label: i18n.t('newOrder.senderZipCode'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 收件人
  { prop: 'receiverAlias', label: i18n.t('collectionCenter.recipientS'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 收件人州
  { prop: 'receiverState', label: i18n.t('newOrder.RecipientState'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 收件人城市
  { prop: 'receiverCity', label: i18n.t('collectionCenter.receiveCity'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 收件人邮编
  { prop: 'receiverZipcode', label: i18n.t('collectionCenter.Recipientzc'), width: 160, fixed: 'left', highlight: false, disabled: false },
  // 发票金额
  { prop: 'totalInvoiceMoney', label: i18n.t('GlobalSetObj.TheInvoiceAmount'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 总重量
  { prop: 'totalWeight', label: i18n.t('GlobalSetObj.totalWeightKG'), width: 140, fixed: 'left', highlight: false, disabled: false },
  // 来源
  { prop: 'feeSource', label: i18n.t('receivablePayable.source'), width: 120, fixed: 'left', highlight: false, disabled: false },
  // cte推送状态
  { prop: 'customerSendTime2', label: i18n.t('basicData.CTE'), width: 160, fixed: 'left', highlight: false, disabled: false }
];

// 业务类型
export const BUSINESS_TYPE = Object.freeze({
  0: {
    label: i18n.t('collectionCenter.expressDelivery'), // 快递
    value: 0
  },
  1: {
    label: i18n.t('collectionCenter.lanshou'), // 揽收
    value: 1
  },
  2: {
    label: i18n.t('collectionCenter.dispatch'), // 派送
    value: 2
  }
});

// 账单类型
export const EXPRESS_TYPE = Object.freeze({
  0: {
    label: i18n.t('basicData.OrdinaryPickUp'), // 普通揽收
    value: 0
  },
  1: {
    label: i18n.t('basicData.StockingAndPickup'), // 备货揽收
    value: 1
  },
  2: {
    label: i18n.t('navbar.bigbusinessType'), // 大件快递
    value: 2
  },
  3: {
    label: i18n.t('receivablePayable.regularExpress'), // 普通快递
    value: 3
  },
  4: {
    label: i18n.t('receivablePayable.d2DExpress'), // D2D快递
    value: 4
  }
});

// 订单类型
export const ORDER_TYPE = Object.freeze({
  'order_number': {
    label: i18n.t('basicData.OrderNumber'),
    value: 'order_number'
  },
  'waybill_number': {
    label: i18n.t('GlobalSetObj.waybillNumber'),
    value: 'waybill_number'
  },
  'customer_number': {
    label: i18n.t('newOrder.orderNumber'),
    value: 'customer_number'
  }
});

// 客户类型
export const CUSTOMER_TYPE = Object.freeze({
  'order_customer': {
    label: i18n.t('basicData.OrderingCustomer'),
    value: 'order_customer'
  },
  'settlement_customer': {
    label: i18n.t('basicData.SettlementCustomer'),
    value: 'settlement_customer'
  }
});

export const QUERY_PARAMS = {
  providerId: '', // 应收主体id
  siteId: '', // 网点id
  customerId: '', // 客户id
  customerCodeId: '', // 客户编号
  merchantName: '', // 商户
  timeField: 'operate_time', // 查询时间类型
  startTime: '', // 业务开始时间
  endTime: '', // 业务结束时间
  numberField: 'waybill_number', // waybill_number: 业务单号 customer_number: 客户单号
  numberList: [], // 业务单号
  isAccept: null, // 是否已支付
  billType: null, // 账单类型
  payType: null, // 支付方式
  isGenBill: null, // 是否生成对账单
  businessType: null, // 业务类型 0:快递系统业务 1:揽收系统业务
  subBusinessType: null, // 明细业务类型
  collectType: null, // 揽收方式
  collectionCategory: null, // 揽收类型
  cargoType: null, // 货物类型
  expressType: null, // 服务类型
  billBatchNumber: '', // 批次号
  feeName: '', // 费用类型名称
  feeCode: '',
  status: '', // 订单状态
  // handlerId: '', // 经办人
  receiveState: '', // 收件人州
  senderState: '' // 发件人州
};
